import ky from 'ky'
import queryString from 'query-string'
import { Component, createResource, Match, onMount, Switch } from 'solid-js'

import { AmicusArraySchema } from '@/types/AmicusBriefs'
import { LoadingSpinner } from '@components/LegacyIcons'
import { getCurrentElement } from 'solid-element'
import { ZodError } from 'zod'
import { AmicusBriefsTable } from './AmicusBriefsTable'

const wpQueryApiBase = `${window.location.origin}/wp-json/wp/v2`
interface AmicusBriefsProps {
  class?: string
}

async function fetchBriefs() {
  try {
    const requestUrl = queryString.stringifyUrl({
      url: [wpQueryApiBase, 'amicus_brief'].join('/'),
    })

    const data = await ky.get(requestUrl).json()

    const briefs = AmicusArraySchema.parse(data)

    return briefs
  } catch (error) {
    if (error instanceof Error) {
      throw new Error(error.message)
    }
    if (error instanceof ZodError) {
      throw new Error(error.message)
    }
    throw new Error('Unknown error')
  }
}
export const AmicusBriefsApp: Component<AmicusBriefsProps> = () => {
  const [briefsData] = createResource(fetchBriefs)
  onMount(() => {
    const el = getCurrentElement()
    el.classList.add('block')
  })

  return (
    <div class="mml-onemagnify-plugin">
      <Switch>
        <Match when={briefsData.loading}>
          <div class="flex h-200 items-center justify-center">
            <div>
              <LoadingSpinner class="size-96" />
            </div>
          </div>
        </Match>
        <Match when={briefsData.state === 'ready' && briefsData()} keyed>
          {(briefs) => (
            <>
              <h3 class="!mt-0">Filter By:</h3>
              <AmicusBriefsTable data={briefs} />
            </>
          )}
        </Match>
        <Match when={briefsData.state === 'errored' && briefsData.error} keyed>
          {(error) => (
            <div>
              <p>Error fetching data.</p>
              <pre>{error.message}</pre>
            </div>
          )}
        </Match>
      </Switch>
    </div>
  )
}
